
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import { $bus } from '@/HostApp/services/Bus';
	import systemLayoutModule from '@/HostApp/services/SystemLayout/SystemLayoutModule';

	@Component({})
	export default class AppView extends Vue {
		@Prop()
		protected layoutTemplateId?: string;
		@Prop()
		protected layoutTemplate?: LAYOUT.ILayoutTemplate;

		protected created(): void {
			const id = this.layoutTemplateId || window.aps.context._view.id;

			if (this.layoutTemplate && id) {
				systemLayoutModule.registerLayoutTemplate({
					id,
					layoutTemplate: this.layoutTemplate
				});
			}

			let [appId, viewId] = id.split('#');
			appId && viewId && $bus.$emit('apps-collector-set-component', { appId, viewId, component: this });
		}

		public apply({ listener, to, from, next, data }: APS.ILifecyclePayload): void {
			if (!this.$listeners.hasOwnProperty(listener)) {
				next && next(data);
			} else {
				[this.$listeners[listener]].flat().forEach((func) => func({ to, from, next, data }));
			}
		}
	}
